import React from 'react';

const PageHeading = ({ children, className = '' }) => {
  return <h1 className={className}>{children}</h1>;
};

export default PageHeading;